// A conta do cliente e os chamados DELE, no nosso backoffice (nível 1, 04/09).
// Nada aqui fala com a Octadesk.
import axios from "axios";
import { MOTOR_API } from "./octadesk-host";

export const tokenAtual = () => sessionStorage.getItem("token");

const http = axios.create({ baseURL: MOTOR_API });
http.interceptors.request.use((cfg) => {
  const t = tokenAtual();
  if (t) cfg.headers.Authorization = "Bearer " + t;
  return cfg;
});
// Sessão vencida (o token de acesso tem prazo): volta para a entrada, sem
// fingir que a ação aconteceu.
http.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401 && tokenAtual()) {
      sessionStorage.clear();
      window.location.href = "/authenticate?expirou=1";
    }
    return Promise.reject(err);
  }
);

/** A mensagem que o servidor deu, ou a padrão. Esconder a razão já custou um teste inteiro (04/09). */
export const mensagemDe = (err, padrao) =>
  (err && err.response && err.response.data && err.response.data.message) || padrao;

export async function entrar(email, senha) {
  const r = await http.post("/auth/login", { email, senha });
  const d = r.data || {};
  const token = d.accessToken || d.token || (d.data && (d.data.accessToken || d.data.token));
  const usuario = d.user || d.usuario || (d.data && (d.data.user || d.data.usuario)) || {};
  if (!token) throw new Error("O servidor não devolveu o token de acesso.");
  return { token, usuario };
}

export const criarConta = (email, nome) => http.post("/publico/conta/cadastrar", { email, nome });
/** nao_encontrado | sem_senha | com_senha — a orientação da tela de entrada. */
export const situacaoDoEmail = async (email) => (await http.post("/publico/conta/situacao", { email })).data.data.situacao;
export const esqueciSenha = (email) => http.post("/auth/forgot-password", { email });
export const definirSenha = (token, senha) => http.post("/auth/first-access", { token, senha });
export const redefinirSenha = (id, token, novaSenha) => http.post("/auth/reset-password", { id, token, novaSenha });

export const meusChamados = async () => (await http.get("/publico/chamados/meus")).data.data;
export const meuChamado = async (id) => (await http.get(`/publico/chamados/${id}`)).data.data;
export const responderChamado = async (id, corpo) => (await http.post(`/publico/chamados/${id}/responder`, { corpo })).data.data;

// 📎 16/09: os ARQUIVOS do chamado. O e-mail de aviso dizia "abra o chamado para
// baixar" e esta porta não mostrava anexo nenhum. O servidor só devolve o que o
// cliente pode ver (o que ele mandou e o que foi em resposta pública — nunca
// anotação interna) e só do chamado que é DELE.
export const anexosDoMeuChamado = async (id) => (await http.get(`/publico/chamados/${id}/anexos`)).data.data;

/** Baixa pelo servidor (com o token) e entrega ao navegador; o link temporário é revogado. */
export async function baixarAnexoMeu(anexoId, nome) {
  const r = await http.get(`/publico/chamados/anexos/${anexoId}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = nome || "arquivo";
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default http;
